import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Box, BoxBackLink } from 'components/common/box';
import { PathStepParticipants, PathStepSummary } from '.';

import type { GetPathStepsRes } from 'shared-types/responses';

interface Props {
  stepId: number;
}

const PathStep = ({ stepId }: Props) => {
  const {
    messages,
    pageState: { path }
  } = useReduxState();

  const { data, loading } = useApiData<GetPathStepsRes>({
    url: `/admin/paths/${path.id}/steps?stepId=${stepId}&isDetailed=true`,
    onlyIf: Boolean(stepId)
  });

  return (
    <div className="step">
      <Box
        loading={loading}
        title={
          <BoxBackLink
            as={`/admin/paths/${path.id}`}
            href="/admin/paths/[pathId]"
            text={messages.commonAllPathSteps}
          />
        }
      >
        <PathStepSummary detailedView={true} step={data?.steps[0]} />
      </Box>

      {data?.steps[0] ? (
        <div className="users">
          <PathStepParticipants stepId={data?.steps[0].id} />
        </div>
      ) : null}

      <style jsx>{`
        .users {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default PathStep;
